/** Combos catalog + QC are deferred in the current phase. Set REACT_APP_ENABLE_COMBOS=true to show. */
export const isCombosEnabled = (): boolean => {
	const v = process.env.REACT_APP_ENABLE_COMBOS;
	if (v === undefined || v === '') return false;
	return String(v).toLowerCase().trim() === 'true';
};
